import { useCallback, useEffect, useRef, useState } from 'react';
import {
  createExam,
  deleteExam,
  fetchUpcomingExams,
  hasSchedulerContext,
  updateExam,
} from '../services/schedulerApi';

const useUpcomingExams = () => {
  const [exams, setExams] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const requestIdRef = useRef(0);
  const isAuthenticated = hasSchedulerContext();

  const loadExams = useCallback(async () => {
    const requestId = requestIdRef.current + 1;
    requestIdRef.current = requestId;

    if (!hasSchedulerContext()) {
      setExams([]);
      setError('');
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError('');
    const response = await fetchUpcomingExams();
    if (requestId !== requestIdRef.current) return;

    if (response?.error) {
      setExams([]);
      setError(response.error);
    } else {
      setExams(Array.isArray(response) ? response : []);
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    loadExams();
    return () => {
      requestIdRef.current += 1;
    };
  }, [loadExams]);

  const saveExam = async (exam) => {
    const response = exam.sno ? await updateExam(exam) : await createExam(exam);
    if (response?.error) throw new Error(response.error);
    await loadExams();
    return {
      ...exam,
      sno: response?.sno || exam.sno,
    };
  };

  const removeExam = async (sno) => {
    const response = await deleteExam(sno);
    if (response?.error) throw new Error(response.error);
    await loadExams();
  };

  return {
    error,
    exams,
    isAuthenticated,
    isLoading,
    loadExams,
    removeExam,
    saveExam,
  };
};

export default useUpcomingExams;
